export const SET_FOOD_ITEM = 'SET_FOOD_ITEM';
export const SET_FOOD_PACKAGE_PRICE = 'SET_FOOD_PACKAGE_PRICE';
export const UPDATE_FOOD_PACKAGE_PRICE_WITH_TOPPINGS =
  'UPDATE_FOOD_PACKAGE_PRICE_WITH_TOPPINGS';
export const INCREMENT_FOOD_PACKAGE_COUNT = 'INCREMENT_FOOD_PACKAGE_COUNT';
export const DECREMENT_FOOD_PACKAGE_COUNT = 'DECREMENT_FOOD_PACKAGE_COUNT';
export const SET_CHOICE_CATEGORIES = 'ADD_CHOICE_OPTIONS';
export const TOGGLE_CHECKBOX_OPTION = 'TOGGLE_CHECKBOX_OPTION';
export const SET_SPECIAL_INSTRUCTION = 'SET_SPECIAL_INSTRUCTION';
export const SET_MENU_LIST = 'SET_MENU_LIST';
export const SET_IS_TAKEOUT = 'SET_IS_TAKEOUT';
